import React, { useEffect, useState, useRef } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/Navbar/logo.png';
import { Link } from 'react-router-dom';

function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mastersOpen, setMastersOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const [operationsOpen, setOperationsOpen] = useState(false);
  const [usersOpen, setusersOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSectionToggle = (section) => {
    if (section === 'masters') setMastersOpen(!mastersOpen);
    else if (section === 'admin') setAdminOpen(!adminOpen);
    else if (section === 'operations') setOperationsOpen(!operationsOpen);
    else if (section === 'users') setusersOpen(!usersOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Navbar for mobile with hamburger icon */}
      <Navbar className="bg-body-tertiary nav px-md-5 px-2 py-3 fixed-top navbar d-md-none">
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto navlinks">
            <Nav.Link href="#" onClick={toggleSidebar}>
              <i className="bi bi-list hamburger-icon"></i>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`sidebar ${sidebarOpen ? 'open' : ''}`}
      >
        <img src={logo} alt="logo" className="logo" />
        <button className="close-btn d-md-none" onClick={toggleSidebar}>
          <i className="bi bi-x-circle"></i>
        </button>

        {/* Masters Section */}
        <ul className="navmenu">
          <li className="navlink" onClick={() => handleSectionToggle('masters')}>
            <span className='fs-6 me-2'>Masters</span>
            <i className={`bi ${mastersOpen ? 'bi-chevron-double-up' : 'bi-chevron-double-down'}`}></i>
          </li>
          {mastersOpen && (
            <ul className="submenu">
              <li><Link to="itemtypes" className='fs-6'>Categories</Link></li>
              <li><Link to="categories" className='fs-6'>Sub Categories</Link></li>
              <li><Link to="items" className='fs-6'>Items</Link></li>
              <li><Link to="media" className='fs-6'>Media</Link></li>
              <li><Link to="programs" className='fs-6'>Programs</Link></li>
              <li><Link to="residential" className='fs-6'>Residential</Link></li>
              <li><Link to="filters" className='fs-6'>Filters</Link></li>  
              <li><Link to="programunits" className='fs-6'>Program Units</Link></li>
              <li><Link to="contact" className='fs-6'>Contact Info</Link></li>
              <li><Link to="publicholidays" className='fs-6'>Public Holidays</Link></li>
              <li><Link to="seasons" className='fs-6'>Seasons</Link></li>
              <li><Link to="groceries" className='fs-6'>Groceries</Link></li>
              <li><Link to="generalpreferences" className='fs-6'>General Preferences</Link></li>
            </ul>
          )}

          {/* Administration Section */}
          <li className="navlink" onClick={() => handleSectionToggle('admin')}>
            <span className='fs-6 me-2'>Administration</span>
            <i className={`bi ${adminOpen ? 'bi-chevron-double-up' : 'bi-chevron-double-down'}`}></i>
          </li>
          {adminOpen && (
            <ul className="submenu">
              <li><Link to="accounts" className='fs-6'>Account</Link></li>
              {/* <li><Link to="accountlist" className='fs-6'>Account List</Link></li>
              <li><Link to="client" className='fs-6'>Client</Link></li> */}
              <li><Link to="guests" className='fs-6'>Guests</Link></li>
            </ul>
          )}

          {/* Operations Section */}
          <li className="navlink" onClick={() => handleSectionToggle('operations')}>
            <span className='fs-6 me-2'>Operations</span>
            <i className={`bi ${operationsOpen ? 'bi-chevron-double-up' : 'bi-chevron-double-down'}`}></i>
          </li>
          {operationsOpen && (
            <ul className="submenu">
              <li><Link to="booking" className='fs-6'>Booking</Link></li>
              <li><Link to="bookingslist" className='fs-6'>Bookings List</Link></li>
              <li><Link to="bookingcalendar" className='fs-6'>Booking Calendar</Link></li>
              <li><Link to="orders " className='fs-6'>Place Orders</Link></li>
              <li><Link to="orderlist" className='fs-6'>Order List</Link></li>
              <li><Link to="report" className='fs-6'>Report</Link></li>
            </ul>
          )}

          {/* users */}
          <li className='navlink' onClick={() => handleSectionToggle('users')}>
          <span className='fs-6 me-2'>Users</span>
          <i className={`bi ${usersOpen ? 'bi-chevron-double-up' : 'bi-chevron-double-down'}`}></i>
          </li>
          {usersOpen && (
            <ul className='submenu'>
              <li><Link to="users" className='fs-6'>Users</Link></li>
            </ul>
          )

          }
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
